import type { TileListSessionContext } from '@tilelist/application/core/TileListInitialSession.ts';
import type { OnEx, OnExServerData } from '@tilelist/domain/experiments/OnEx.ts';
import { OnExAdapter, DEFAULT_ONEX as _DEFAULT_ONEX } from '@tilelist/domain/experiments/OnExAdapter.ts';

export type { OnEx };
export type { OnExServerData };

/**
 *
 *
 */
export function createOnExFromServerData(data: OnExServerData): OnEx {
    return OnExAdapter.fromServer(data);
}

/**
 *
 *
 */
export const DEFAULT_ONEX: OnEx & OnExServerData = _DEFAULT_ONEX;

/**
 *
 *
 */
export function createTileListOnEx(context: TileListSessionContext): OnEx {
    return createOnExFromServerData(context.onexServerData);
}
